class ConnectionService {
  public hasConnection() {
    return window.navigator.onLine;
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ConnectionService();
